import { __read } from 'tslib';
import * as React from 'react';

var useMediaQuery = function (limit, width) {
    var _a = __read(React.useState(false), 2), targetReached = _a[0], setTargetReached = _a[1];
    var updateTarget = React.useCallback(function (e) {
        if (e.matches) {
            setTargetReached(true);
        }
        else {
            setTargetReached(false);
        }
    }, []);
    React.useEffect(function () {
        if (typeof window !== undefined) {
            var media_1 = window.matchMedia("(".concat(limit, "-width: ").concat(width, "px)"));
            /**
             * We need to use deprecated `addListener` instead of `addEventListener` to be IE11 compatible.
             */
            media_1.addListener(updateTarget);
            // Check on mount (callback is not called until a change occurs)
            if (media_1.matches) {
                setTargetReached(true);
            }
            return function () { return media_1.removeListener(updateTarget); };
        }
    }, []);
    return targetReached;
};
var useMinMediaQuery = function (width) { return useMediaQuery('min', width); };
var useMaxMediaQuery = function (width) { return useMediaQuery('max', width); };

export { useMaxMediaQuery, useMinMediaQuery };
//# sourceMappingURL=useMediaQuery.esm.js.map
